import { render, staticRenderFns } from "./ReportSaleChannel.vue?vue&type=template&id=24f82b6e&"
import script from "./ReportSaleChannel.vue?vue&type=script&lang=js&"
export * from "./ReportSaleChannel.vue?vue&type=script&lang=js&"
import style0 from "./ReportSaleChannel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports